<template>
  <svg width="25" height="26" viewBox="0 0 25 26" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M21.5 4L16 4M21.5 4V9.5M21.5 4L14 12" stroke="currentColor" />
    <path
      d="M14 6H7.5C6.39543 6 5.5 6.89543 5.5 8V18C5.5 19.1046 6.39543 20 7.5 20H17.5C18.6046 20 19.5 19.1046 19.5 18V11.5"
      stroke="currentColor"
    />
  </svg>
</template>
